// const URL = process.env.NODE_ENV === 'production' ? 'https://ocvcapp-api-dev.azurewebsites.net' : 'http://localhost:22742';
const URL = asdcom.config.hostUrl;
export default URL;
